import {Injectable} from '@angular/core';
import {AbstractModelService} from '../model/abstract-model.service';
import {ApiClientService} from '../api-client/api-client.service';
import {TranslationDomain} from '../../models/translation/translation-domain';
import {Observable, Subscriber} from 'rxjs';
import {ApiResponse} from '../../api/api-response';

@Injectable({
  providedIn: 'root'
})
export class TranslationDomainService extends AbstractModelService<TranslationDomain> {

  constructor(apiClient: ApiClientService) {
    super(apiClient, '/translation-domain', TranslationDomain);
  }

  translate(translationDomain: TranslationDomain, targetLocale: string, overwrite: boolean, botPromptId: number | null = null): Observable<void> {
    const data: any = {overwrite};
    if (botPromptId) {
      data.botPromptId = botPromptId;
    }

    return new Observable<void>((subscriber: Subscriber<any>): void => {
      this.apiClient.post(this.routePath + '/' + translationDomain.id + '/translate/' + targetLocale, {}, data).subscribe({
        next: (response: ApiResponse) => {
          subscriber.next(response.getData());
          subscriber.complete();
        },
        error: (error) => {
          subscriber.error(error);
          subscriber.complete();
        }
      });
    });
  }

  reviewDomainLocale(translationDomain: TranslationDomain, locale: string, reviewed: boolean): Observable<any> {
    return new Observable<void>((subscriber: Subscriber<any>): void => {
      const params = {
        domainId: translationDomain.id,
        locale,
        reviewed
      };

      this.apiClient.put('/translation-domain-locale', {}, params).subscribe({
        next: (response: ApiResponse) => {
          subscriber.next(response.getData());
          subscriber.complete();
        },
        error: (error) => {
          subscriber.error(error);
          subscriber.complete();
        }
      });
    });
  }
}
